<template>
  <font-awesome-icon icon="spinner" spin class="text-3xl text-airbnbRed" />
</template>
